import { computed, inject, Injectable, signal, WritableSignal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { ClientJsonItem, MediaItem, SettingsRepository } from "sp-client";
import { SessionService } from "../session/session.service";
import { SP_IMAGE_URL } from "./image-url.token";

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private readonly settingsRepository = inject(SettingsRepository);
    private readonly sessionService = inject(SessionService);
    protected imageBaseUrl = inject(SP_IMAGE_URL);

    private readonly logoPreviewOverride: WritableSignal<MediaItem | undefined> = signal(undefined);

    clients = rxResource<ClientJsonItem[] | undefined, void>({
        loader: () => this.settingsRepository.getClient(undefined, 'media'),
    });

    logoPath = computed(() => {
        const previewLogo = this.logoPreviewOverride();
        if (previewLogo?.path) {
            return this.imageBaseUrl + previewLogo.path;
        }

        const client = this.clients.value();
        if (!client || client.length === 0) return undefined;
        
        const mediaPath = client[0]?.media?.path;
        if (!mediaPath) return undefined;

        return this.imageBaseUrl + mediaPath;
    });

    public setLogoPreview(mediaItem: MediaItem | undefined): void {
        this.logoPreviewOverride.set(mediaItem);
    }

    public clearLogoPreview(): void {
        this.logoPreviewOverride.set(undefined);
    }
}